import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';

import { transformOptionsByPath } from '@openx/components-deal/lib/utils/transformOptionsByPath.ts';
import type { HierarchyItem } from '@openx/types/hierarchyItem.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useBrandsOptionsFetch: DealProviderConfig['useBrandsOptionsFetch'] = () => {
  const {
    data: { optionsByPath = [] } = {},
    loading,
    refetch,
  } = useOptionsByPathQuery({
    variables: {
      path: 'deal.brand_salesforce_id',
    },
    fetchPolicy: 'network-only',
  });

  const { list, mapById } = useMemo(() => transformOptionsByPath<HierarchyItem>(optionsByPath), [optionsByPath]);

  return {
    list,
    loading,
    mapById,
    refetch,
  };
};
